export enum MessageType {
  All = "all",
  Business = "business",
  Message = "message",
}

export enum MessageStatus {
  Unread = 2,
  Read = 1,
}

export enum MessageTemplate {
  Activity = "ACTIVITY",
  AdTask = "AD_TASK",
}

export enum MessageClickType {
  link = "link",
  sample = "sample",
  product = "product",
  membership = "membership",
  highCommission = "highCommission",
  adTaskDetail = "adTaskDetail",
}

export enum MessageDetailStatusType {
  Unread = 0,
  Read = 1,
}

export enum MessageDetailItemType {
  Activity = "activity",
  Order = "order",
}
